module.exports = __webpack_public_path__ + "assets/img/不良处理中.cc6f1a5a.svg";